// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FYXg","col":"styles_col__2uvfp"};